export default __webpack_public_path__ + "static/media/historia3.dd997b71.png";